import { IconButton, Tooltip } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// Shown in place of every salary figure while amounts are hidden; the real value is not rendered.
export const MASKED_AMOUNT = "••••••";

const SHOW_AMOUNTS_LABEL = "Show amounts";
const HIDE_AMOUNTS_LABEL = "Hide amounts";

const PayslipAmountToggle = ({ visible, onToggle }) => {
  const label = visible ? HIDE_AMOUNTS_LABEL : SHOW_AMOUNTS_LABEL;
  return (
    <Tooltip title={label}>
      <IconButton size="small" aria-label={label} onClick={onToggle}>
        {visible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
};

export default PayslipAmountToggle;
